// This singleton is designed for managing tokens in the initialization. We can add a new token,
// save the id, and then cancel async from the main method. Tokens are initialized to false to
// imply the request as not been cancelled (always assert ! on the token value to know.) Note
// there are more complex ways to implement this pattern but this is the most straightforward
// and simplistic way to implement the pattern in such a way to manage multiple tokens.

const tokens = {};
let idCounter = 0;

export default {
  cancelAll() {
    Object.keys(tokens).forEach((id) => tokens[id] = true);
  },
  addToken() {
    tokens[idCounter] = false;
    const id = idCounter;
    idCounter += 1;
    return id;
  },
  getTokenValue(id) {
    return tokens[id];
  },
  removeToken(id) {
    delete tokens[id];
  },
};
